import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getToken, removeToken, getLoginId, removeLoginId } from '@/utils/auth'

const service = axios.create({
  baseURL: process.env.NODE_ENV  === 'development' ?
  // 'http://localhost:8080/api' : process.env.VUE_APP_BASE_API, // url = base url + request url
  'http://180.168.215.70:19048' : process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 600000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.token) {
      config.headers['accessToken'] = getToken()
      config.headers['loginId'] = getLoginId()
    }
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return response.data
    }
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (error.config.url.includes('/401')) {
            Message({
              message: error.response.data ? error.response.data.message : 'error',
              type: 'error',
              duration: 3 * 1000
            })
          } else {
            router.replace({
              path: '/401'
            })
          }
          break
          // return Promise.reject(error.response.data)
        case 403:
          if (error.config.url.includes('/login')) {
            Message({
              message: error.response.data.message,
              type: 'error',
              duration: 3 * 1000
            })
          } else {
            removeToken()
            removeLoginId()
            router.replace({
              path: '/login'
            })
            store.commit('app/TOGGLE_LOADING', false)
          }
          break
        case 400:
          Message({
            message: '请检查信息是否填写正确',
            type: 'error',
            duration: 3 * 1000
          })
          break
          // return Promise.reject(error.response.data)
        default:
          Message({
            message: error.response.data.message ? error.response.data.message : 'error',
            type: 'error',
            duration: 3 * 1000
          })
          if (error.responses.data.code === 500000) {
            removeToken()
            removeLoginId()
            router.replace({
              path: '/login'
            })
            return false
          }
          // return Promise.reject(error.response.data)
      }
    } else {
      // Message({
      //   message: '请求超时～',
      //   type: 'error',
      //   duration: 3 * 1000
      // })
    }
    return Promise.reject(error.response.data)
  }
)

export default service
